import styled from 'styled-components';
import D from '@assets/themes/dimensions';

interface IStyleProps {
  height?: string;
};

export const Root = styled.div`
  display: flex;
`

export const RightContainerInit = styled.div`
  position: relative;
  height: 100vh;
  overflow: hidden;
  transition: width 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`

export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
`
